import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import ToolBlock from "../../../components/DataBaseComponents/basesBuildings/ToolBlock/ToolBlock";
import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ConfirmationModal from "./../../../components/confirmationModal/confirmationModal";
import ModalWindowForBasesBuilding from "../../../components/DataBaseComponents/basesBuildings/modalWindowForBasesBuilding/ModalWindowForBasesBuilding";
import NotificationWindow from "../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";

import { getDataBasesBuildingBySearchParams } from "../../../redux/actions";

import {
  options,
  setOptionsForInputsNsiStatusRHF,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import {
  ARCHIVE_LOADING_BASES,
  SET_ERROR_MESSAGE_BASES,
} from "../../../redux/types";
import { BUILDING_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import styles from "./BasesBuildings.module.css";

const BASE_ADD = "База (сооружение) создана!";
const BASE_UPDATE = "Изменения успешно сохранены!";

export default function BasesBuildings() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useState({
    ownerCommonName: "",
    location: "",
    ownerUnp: "",
    checkStatus: 0,
    startDate: "",
    endDate: "",
  });
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [show, setShow] = useState(false);
  const [buttonType, setButtonType] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const dataFromStateBases = useSelector((state) => {
    const { basesBuildingReducer } = state;
    return basesBuildingReducer;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.BASES_BUIDING?.creationOfTheRkBase?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.BASES_BUIDING?.viewingTheRkDatabase?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.BASES_BUIDING?.editingTheRcDatabase?.chapterActionId,
  );

  const handleShow = (event) => {
    event.stopPropagation();
    setButtonType(event.currentTarget.dataset.type);
    setShow(true);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        ownerCommonName: "",
        location: "",
        ownerUnp: "",
        checkStatus: 0,
        startDate: "",
        endDate: "",
      }),
    );
    dispatch(
      getDataBasesBuildingBySearchParams(
        {
          ownerCommonName: "",
          location: "",
          ownerUnp: "",
          checkStatus: 0,
          startDate: "",
          endDate: "",
        },
        0,
      ),
    );
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    dispatch(getDataBasesBuildingBySearchParams(searchParams, 0));
  };

  useEffect(() => {
    if (dictionaryReducer.newNsiCheckStatus.length > 0) {
      setOptionsForInputsNsiStatusRHF(
        dictionaryReducer.newNsiCheckStatus,
        options.inputsBasesBuildings.key,
      );
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.newNsiCheckStatus.length > 0) {
      setOptionsForInputsNsiStatusRHF(
        dictionaryReducer.newNsiCheckStatus,
        options.inputsBasesBuildings.key,
      );
    }
  }, []);

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const closeArchiveModal = () => {
    dispatch({ type: ARCHIVE_LOADING_BASES });
    setShowArchiveModal(false);
  };

  useEffect(() => {
    if (dataFromStateBases.archiveStatus === "success") {
      setShow(false);
      setShowArchiveModal(true);
      dispatch(getDataBasesBuildingBySearchParams(searchParams, selectedPage));
    }

    if (dataFromStateBases.archiveStatus === "error") {
      setShowArchiveModal(true);
    }
  }, [dataFromStateBases.archiveStatus]);

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataBasesBuildingBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsBasesBuildings}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        data={dataFromStateBases?.data?.content}
        buildingId={selectedRowData?.id}
        showForm={handleShow}
        setButtonType={setButtonType}
        editAccess={editAccess}
        viewAccess={viewAccess}
        addAccess={addAccess}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={BUILDING_COLUMNS}
        data={dataFromStateBases.data.content || []}
        totalPages={dataFromStateBases.data.totalPages || 0}
        totalElements={dataFromStateBases.data.totalElements || 0}
        selectedPage={selectedPage}
      />
      {show && (
        <ModalWindowForBasesBuilding
          setShow={setShow}
          show={show}
          type={buttonType}
          buildingId={selectedRowData?.id}
          setShowConfirmationModal={setShowConfirmationModal}
        />
      )}
      {Boolean(dataFromStateBases.errorMessage) && (
        <NotificationWindow
          isError={true}
          show={Boolean(dataFromStateBases.errorMessage)}
          headerText={"Уведомление"}
          onClose={() => {
            dispatch({
              type: SET_ERROR_MESSAGE_BASES,
              data: "",
            });
          }}
          messageText={dataFromStateBases.errorMessage}
        />
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          isOpen={showConfirmationModal}
          title={buttonType === "add" ? BASE_ADD : BASE_UPDATE}
          onClose={() => {
            setShowConfirmationModal(false);
          }}
        />
      )}
      {showArchiveModal && (
        <ConfirmationModal
          isOpen={showArchiveModal}
          title={dataFromStateBases.archiveText}
          onClose={closeArchiveModal}
        />
      )}
    </div>
  );
}
